export enum SystemStatus {
  notMonitored = 'NotMonitored',
  online = 'Online',
  offline = 'Offline',
  warning = 'Warning',
  malfunction = 'Malfunction',
}
